import React from 'react';
import styled from 'styled-components';

const Navbar = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.1rem 2rem;
  color:#fff;
`;

const NavBrand = styled.h1`
  font-size: 1.5rem;
  font-weight: bold;
`;

const NavLinks = styled.ul`
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
`;

const NavLink = styled.li`
  margin: 0 1rem;
`;

const Hero = styled.header`
  background: rgba(0, 0, 0, 0.5) url(../images/lap4.jpg);
    background-size: cover;
    background-blend-mode: darken;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const HeroTitle = styled.h1`
  font-size: 3rem;
  font-weight: bold;
  color: #fff;
  text-shadow: 1px 1px #000;
`;

const About = styled.section`
  padding: 2rem;
  text-align: center;
`;

const AboutTitle = styled.h2`
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 2rem;
  color:#fff;
`;

const AboutText = styled.p`
  font-size: 1.2rem;
  line-height: 1.5;
  color:#fff;

`;

const Contact = styled.section`
  padding: 2rem;
  ${'' /* background: #fafafa; */}
  background: rgba(0, 0, 0, 0.745);

`;

const ContactTitle = styled.h2`
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 2rem;
  text-align: center;
  color:#fff;

`;

const ContactForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ContactInput = styled.input`
  width: 50%;
  padding: 1rem;
  margin-bottom: 2rem;
  font-size: 1.2rem;
`;

const ContactTextArea = styled.textarea`
  width: 50%;
  padding: 1rem;
  margin-bottom: 1rem;
  font-size: 1.2rem;
`;

const ContactButton = styled.button`
  padding: 1rem;
  background: #000;
  color: #fff;
  font-size: 1.2rem;
  border: none;
  cursor: pointer;
`;

const Footer = styled.footer`
  padding: 1rem;
  text-align: center;
`;

const FooterText = styled.p`
  font-size: 1.2rem;
  color: #999;
`;

function Portfolio() {
  return (
    <>
      <Navbar  className='linc'>
        <NavBrand>Yaseen</NavBrand>
        <NavLinks className='link'>
<a className='links' href='/'>Home</a>
<a className='links' href='#about'>About</a>
<a className='links' href='#contact'>Contact</a>
</NavLinks>
</Navbar>
<Hero className='hero'>
<div className="name-title">
<p className='hi'>HI THERE !</p>
<p className='name'>I'M Yaseen Pasha</p>
<HeroTitle className='hero-title'>Full-Stack web Developer and Engineer</HeroTitle>

</div>
</Hero>
<About id='about'>
<AboutTitle className='about-title'>About <span className='me'>Me</span></AboutTitle>
<AboutText className='about-txt'>
I am a motivated and enthusiastic full-stack web developer with a passion for creating static, dynamic and interactive web applications. With experience in JavaScript, HTML, CSS, WordPress, Bootstrap and various frameworks such as ReactJS, NodeJS, ExpressJS, PostMan, RESTFULL API, Template Engines, Github, DataBases I am confident in my ability to bring your project to life.
</AboutText>
</About>
<Contact id='contact'>
<ContactTitle className='about-title'>Get in <span className='me'>Touch</span></ContactTitle>
<ContactForm action="https://formspree.io/f/myyakjgk" method="POST">
<ContactInput type="text" name = "name" id="name" className='input' placeholder="Your Name" required/>
<ContactInput type="email" name = "email" id="email" className='input' placeholder="Your Email" required/>
<ContactInput type="text" name = "phone" id="phone" className='input' placeholder="Mobile Number" required/>
<ContactTextArea name="message" id="message" cols="30" rows="5" className='input' placeholder="Message" required/>
<ContactButton type="submit" className='btn'>Submit</ContactButton>
</ContactForm>
</Contact>
<Footer>
<FooterText className='footer'>Created By <a class="footname" href="https://www.instagram.com/yaseen07_/" target="_blank">Yaseen </a>Copyright © {new Date().getFullYear()} webwonders.one All rights reserved</FooterText>
</Footer>
</>
);
}

export default Portfolio;